import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { PricingHistoryService } from '@products/services/pricing-history.service';
import { Logger } from '@utils/logger';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PricingDistributionBaseType } from '../pricing-distribution-base-type.enum';
import { PricingDistributionDisplayComponent } from '../pricing-distribution-component.interface';
import { PricingDistributionConfig } from '../pricing-distribution.config';

const logger = Logger.getLogger('PricingDistributionEntryComponent');

@Component({
  selector: 'ft-pricing-distribution-entry',
  templateUrl: './pricing-distribution-entry.component.html',
  styleUrls: ['./pricing-distribution-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingDistributionEntryComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  @ViewChild('dynamicCmp', { read: ViewContainerRef, static: false }) container;
  componentType: string;
  componentRef: ComponentRef<PricingDistributionDisplayComponent>;
  componentConfig: PricingDistributionConfig;
  isLoading = true;
  errorMsg: string;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
    private pricingHistoryService: PricingHistoryService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.componentType = this.brConfig?.componentType;
    this.componentConfig = PricingDistributionConfig.getConfig(
      this.componentType,
      this.configurationName
    );
    this.changeDetector.detectChanges(); // at this point show component if componentType exists

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );
      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.isLoading = false;
      this.errorMsg = null;

      this.componentRef.instance.populate(
        this.componentConfig,
        this.brConfig,
        this.component,
        this.page
      );

      if (
        this.componentType ===
        PricingDistributionBaseType.PREMIUM_DISCOUNT_ANALYSIS
      ) {
        this.pricingHistoryService.pricingSelection$
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(this.resizeChart);
      }
      this.changeDetector.detectChanges(); // to remove loading message
    } else {
      logger.error(
        'No component found: ',
        this.componentType,
        this.configurationName
      );
      this.errorMsg = `No component found: ${this.componentType}, ${this.configurationName}`;
    }
  }

  resizeChart = (): void => {
    if (this.componentRef.instance?.resizeChart) {
      this.componentRef.instance?.resizeChart();
    }
  };

  ngOnDestroy(): void {
    // clean up dynamic component to avoid memory leaks
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.componentRef?.destroy();
  }
}
